import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';

export default function Videos() {
  const { t } = useTranslation();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/videos').then(r => { setVideos(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="page-header">
        <h1>{t('youtube.pageTitle')}</h1>
        <p>{t('youtube.pageSubtitle')}</p>
      </div>

      <section className="section">
        <div className="container">
          {loading ? (
            <div className="loader"><div className="spinner" /></div>
          ) : videos.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 0', color: '#888' }}>
              <div style={{ fontSize: '4rem', marginBottom: 12 }}>🎥</div>
              <p>{t('youtube.noVideos')}</p>
            </div>
          ) : (
            <div className="youtube-grid">
              {videos.map(v => (
                <div key={v._id} className="youtube-card">
                  <div className="youtube-embed-wrap">
                    {v.sourceType === 'upload' ? (
                      <video src={`${API_BASE}${v.url}`} controls />
                    ) : (
                      <iframe
                        src={`https://www.youtube.com/embed/${v.videoId}?rel=0`}
                        title={v.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    )}
                  </div>
                  <div className="youtube-card-body">
                    <h4 className="youtube-card-title">{v.title}</h4>
                    {v.description && <p className="youtube-card-desc">{v.description}</p>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
